import "./WorkCardStyles.css"
import WorkCard from "./WorkCard";
import WorkCardData from "./WorkCardData"

import React from 'react'

import { ProjectCardData, ProjectCardData_2, ProjectCardData_3, ProjectCardData_4 } from './WorkCardData';

const Work = () => {
  return (
    <div className="work-container">
      {/* <h1 className="project-heading" style={{ fontSize: '36px' }} >PROJECTS</h1> */}
      <h1 style={{ fontSize: '24px', textAlign: 'center', margin: '20px' }}>Artificial Intelligence</h1>
      <div className="project-container">
        {ProjectCardData.map((val, ind) => {
          return (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              view={val.view}
              source={val.source}
            />
          )
        })}
      </div >

      <h1 style={{ fontSize: '24px', textAlign: 'center', margin: '20px' }}>Embedded Systems</h1>
      <div className="project-container">
        {ProjectCardData_2.map((val, ind) => {
          return (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              view={val.view}
              source={val.source}
            />
          )
        })}
      </div >

      <h1 style={{ fontSize: '24px', textAlign: 'center', margin: '20px' }}>Software Design</h1>
      <div className="project-container">
        {ProjectCardData_3.map((val, ind) => {
          return (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              view={val.view}
              source={val.source}
            />
          )
        })}
      </div >

      <h1 style={{ fontSize: '24px', textAlign: 'center', margin: '20px' }}>Publications</h1>
      <div className="project-container">
        {ProjectCardData_4.map((val, ind) => {
          return (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              view={val.view}
              source={val.source}
            />
          )
        })}
      </div >


    </div >
  )
}

export default Work;